import * as React from 'react'
import { Link as LinkComponent } from 'widgets-for-react'
import { ImageSize, Link } from '../../../../cms/blocks/types.gen'
import { link } from '../../../../cms/blocks/utils.gen'
import { parseImageUrl } from '../../../../drupal/rendering/image_utils.mod'
import { ParsedMediaImage } from '../../../../drupal/types_and_parser/types'

export type FeaturedContentBlockProps = {
  alignImage: 'right' | 'left'
  // Kept for the CMS field, the decorative shape is part of the card itself
  backgroundImage?: string
  title?: string
  label?: string
  intro?: string
  field_image?: ParsedMediaImage
  image?: number
  image_alt?: string
  image_size?: ImageSize
  primaryButton?: Link
  secondaryButton?: Link
  isStyleguide?: boolean

  button?: {
    text: string
    url: string
  }
  secondaryButtonStyleguide?: {
    text: string
    url: string
  }
  imageStyleguide?: {
    src: string
    srcSet: string
    alt: string
  }
}

export const FeaturedContentBlock = (props: FeaturedContentBlockProps) => {
  const {
    alignImage,
    title,
    label,
    intro,
    button,
    field_image,
    image,
    image_alt,
    image_size,
    primaryButton,
    isStyleguide,
    imageStyleguide,
    secondaryButtonStyleguide
  } = props

  return (
    <section className={`block block--featured-content featured-content featured-content--image-${alignImage}`}>
      <div className="featured-content__container container container--m grid--block">
        <div className="featured-content__inner">
          <div className="featured-content__column featured-content__column--visual">
            {isStyleguide ? (
              <div className="featured-content__visual">
                <img
                  className="featured-content__image lazyload"
                  src="/images/empty.png"
                  data-src={imageStyleguide.src}
                  data-srcSet={imageStyleguide.srcSet}
                  alt={imageStyleguide.alt}
                  sizes="auto"
                  width="450"
                  height="450"
                />
              </div>
            ) : (
              image && (
                <div className="featured-content__visual">
                  <img
                    className="featured-content__image lazyload"
                    src="/images/empty.png"
                    data-src={`${field_image?.field_media_image?.image?.style_urls['450x450']}`}
                    data-srcset={`${parseImageUrl(
                      field_image?.field_media_image?.image?.style_urls['450x450']
                    )} 450x450, ${parseImageUrl(
                      field_image?.field_media_image?.image?.style_urls['600x600']
                    )} 600x600, ${parseImageUrl(field_image?.field_media_image?.image?.style_urls['1200x1200'])}`}
                    alt={image_alt}
                    sizes="auto"
                    width="600"
                    height="600"
                  />
                </div>
              )
            )}
          </div>
          <div className="featured-content__column featured-content__column--message">
            <div className="featured-content__message">
              {label && <span className="featured-content__label label">{label}</span>}
              {title && <h2 className="featured-content__title title--l">{title}</h2>}
              {intro && (
                <div
                  className="featured-content__intro text--styled text--l"
                  dangerouslySetInnerHTML={{ __html: intro }}
                />
              )}
              <div className="featured-content__actions button-group">
                {isStyleguide ? (
                  <>
                    {button && (
                      <LinkComponent className="featured-content__cta button button--primary" to={button.url}>
                        {button.text}
                      </LinkComponent>
                    )}
                    {secondaryButtonStyleguide && (
                      <LinkComponent
                        className="featured-content__cta button button--secondary"
                        to={secondaryButtonStyleguide.url}
                      >
                        {secondaryButtonStyleguide.text}
                      </LinkComponent>
                    )}
                  </>
                ) : (
                  <>
                    {props.primaryButton &&
                      link(
                        props.primaryButton,
                        { classname: 'featured-content__cta button button--primary' },
                        props.primaryButton.title,
                        () => {
                          window.dataLayer.push({
                            event: 'event.refresco',
                            category: 'FeaturedContentBlock',
                            action: props.primaryButton.title,
                            label: window.location.pathname
                          })
                        }
                      )}
                    {props.secondaryButton &&
                      link(
                        props.secondaryButton,
                        { classname: 'featured-content__cta button button--secondary' },
                        props.secondaryButton.title,
                        () => {
                          window.dataLayer.push({
                            event: 'event.refresco',
                            category: 'FeaturedContentBlock',
                            action: props.secondaryButton.title,
                            label: window.location.pathname
                          })
                        }
                      )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
